export function navigateToV3(sk, _url = '') {
  // const url = _url.includes('returnUrl') ? _url.split('?')[0] : _url
  const url = ''

  const alreadyLogginIn = (url || global.window.location.href).indexOf('/login?sk=') >= 0
  let location = newLocation.call(this, url)
    .replace(
      alreadyLogginIn ? /\/login\?sk=[a-zA-Z0-9]+/ : '/login',
      `/login?sk=${sk}`
    )
    .replace('?mfa', '')
    .replace('?returnUrl', '&returnUrl')

  if (window.location.hash === '#/mfa-setup') {
    const url = new URL(location)
    url.hash = `/login?sk=${sk}&returnUrl=${_url}`
    location = url
  }

  if (_url.includes('goToPage=')) {
    const url = new URL(location)
    url.hash = `/login?sk=${sk}&returnUrl=${encodeURIComponent(_url)}`
    location = url
  }

  global.window.location.replace(location)
}

export function navigateToV3Home(user) {
  if (this.$user.$.domain !== 1) {
    const shouldLogin = user && user.sk

    shouldLogin
      ? this.$router.push({ name: 'login', query: { sk: user.sk, noSwitchAccount: true } })
      : this.$router.push({ name: 'home' })
    return
  }

  if (this.$router.currentRoute.query.returnUrl || this.$routerHistory.previous().path.indexOf('returnUrl') >= 0) {
    return
  }

  const location = newLocation.call(this)
    .replace('?noSwitchAccount', '')

  const url = new URL(location)
  const shouldLogin = user && user.sk // && this.$router.currentRoute.name !== 'switchaccount'
  url.search = shouldLogin ? 'noSwitchAccount' : ''
  url.hash = shouldLogin ? `/login?sk=${user.sk}` : '/home'

  global.window.location.replace(url.href)
}

export function newLocation(url) {
  const locationPath = url
    ? new URL(url).pathname
    : global.window.location.pathname
  const env = locationPath.split('/')[1].replace('index.html', '')

  let location = ''
  if (env === '') {
    location = (url || global.window.location.href).replace('.com/#', '.com/-v3/index.html#').replace('.com/index.html', '.com/-v3/index.html')
  } else {
    let newEnv = `${this.api._env.replace('evedonline.', '').replace('.', '')}${'-v3'}`
    newEnv = newEnv.replace('local', 'dev')

    location = (url || global.window.location.href)
      .replace(
        `.com/${env}`,
        `.com/${newEnv}`
      )
      .replace(
        `.com/${env + '/'}`,
        `.com/${newEnv + '/'}`
      )
  }

  return location
}



// WEBPACK FOOTER //
// ./src/core/legacy-auth/gotoV3.js